<template>


  <div class="row">



    <div class="col-12 mb-3">
      <button class="btn btn-primary" @click="$router.push({name: 'edit_voucher' , params: {id: 'new'}})">
        افزودن
        <i class="fas fa-plus"/>
      </button>
      <hr>
    </div>



    <div class="col-12 mb-3">
      <h4 class="text-right text--orange">
        جستجو کد تخفیف
      </h4>
    </div>





    <div class="col-12">
      <form class="text-right">
        <div class="row">



          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="title" class="text-right mb-1">عنوان</label>
              <input id="title" v-model="filters.title" type="text" class="fv-sm form-control" placeholder="عنوان">
            </div>
          </div>



          <div class="col-12 col-sm-6 col-md-4 col-lg-6 col-xl-3">
            <div class="form-group" v-on:keyup.enter="beforeSearch">
              <label for="categories">دسته بندی</label>
              <appCategorySelect id="categories" placeholder="دسته بندی" v-model="filters.category_ids"
                                 :multiple="true"/>
            </div>
          </div>



          <div class="col-12 text-left d-flex">
            <button type="button" @click="$router.push({})" class="btn btn-danger ml-auto">
              حذف فیلترها
              <i class="fas fa-trash"/>
            </button>
            <button @click.prevent="beforeSearch" class="btn btn-info">
              جستجو
              <i class="fas fa-search"/>
            </button>
          </div>



        </div>
      </form>
      <hr>
    </div>






    <div class="col-12">
      <fvTable class="fv-size-lg" v-if="item.length > 0" :fields="fields" :rows="item">
        <template slot="field-#" , slot-scope="scope">
          <span>{{scope.index + 1 + ( (page - 1) * (pagination.page === 1 ? 0 : pagination.per_page ) )}}</span>
        </template>



        <template slot="field-عنوان" slot-scope="scope">
          {{scope.row.title || '---'}}
        </template>



        <template slot="field-تعداد" slot-scope="scope">
          <div v-html="scope.row.count || '---'"/>
        </template>



        <template slot="field-تاریخ انقضا" slot-scope="scope">
          {{$dateTimeFormat(scope.row.expires_at)}}
        </template>


        <template slot="field-تاریخ ثبت" slot-scope="scope">
          {{$dateTimeFormat(scope.row.created_at)}}
        </template>


        <template slot="field-میزان تخفیف" slot-scope="scope">
          {{$priceMask(scope.row.discount)|| 0}}٪
        </template>


        <template slot="field-actions" slot-scope="scope">
          <button @click="$router.push({name: 'edit_voucher' , params : {id: scope.row.id} })"
                  class="btn btn-warning btn-sm">
            تغییر
            <i class="far fa-edit"/>
          </button>
        </template>

		
      </fvTable>

    </div>




    <div class="col-12 text-center mt-5" v-if="Object.keys(item).length && pagination.pages > 1">
      <appPagination :pageCount="pagination.pages" v-model="page" @input="search"/>
    </div>

  </div>
</template>
<script>

	import {mapActions} from "vuex"
	import appUserSelect from "../../components/appUserSelect";
	import appGendersSelect from "../../components/appGendersSelect";
	import appCategorySelect from "../../components/appCategorySelect";
	import appPagination from "../../components/appPagination";
	import appRangeDatePicker from "../../components/appRangeDatePicker";

	export default {
		name: 'vouchers',
		data() {
			return {
				...mapActions('main', [
					'crud'
				]),
				item: [],
				fields: ['#', 'عنوان', 'تعداد', 'میزان تخفیف', 'تاریخ انقضا' ,'تاریخ ثبت', 'actions'],
				query: {},
				filters: {},
				sort: '-_score,-created_at',
				page: 1,
				pagination: {per_page: 50}
			}
		},
		components: {
			appPagination,
			appUserSelect,
			appGendersSelect,
			appCategorySelect,
			appRangeDatePicker
		},
		methods: {
			parseQueries() {
				const {query} = this.$route
				const {page, filters, sort, per_page} = query;
				const filtersObj = filters ? JSON.parse(filters) : {}


				this.sort = sort || '-_score,-created_at'
				this.filters = filtersObj
				this.query = query
				this.page = page ? parseInt(page) : 1
				this.pagination.per_page = per_page
			},
			async getData() {
				this.parseQueries()
				this.$store.commit('main/SET', {key: 'loading', value: true})
				try {
					const apiFilters = await this.$generateFilter(this.filters)
					const item = await this.crud({
						action: 'get',
						section: 'vouchers',
						query: `${this.$queryGenerator(apiFilters, this.sort)}${this.page >= 1 ? `&page=${this.page}` : ''}`,
						perPage: this.pagination.per_page
					})
						const result = item.data.items
						this.item = result
						this.pagination = item.data.pagination
				} catch (e) {
					// console.log(e)
				} finally {
					this.$store.commit('main/SET', {key: 'loading', value: false})
				}
			},
			async search() {
				this.filters = await this.$validateFilter(this.filters)
				await this.$router.push({
					query: {
						filters: Object.keys(this.filters).length > 0 ? JSON.stringify(this.filters) : undefined,
						sort: this.sort || undefined,
						page: this.page,
						per_page: this.pagination.per_page
					}
				})
			},
			beforeSearch() {
				this.page = 1
				this.search()
			},
			changePerPage(value) {
				this.pagination.per_page = value
				this.beforeSearch()
			},
		},

		async created() {
			await this.getData()
		},
		watch: {
			'$route.query'() {
				this.getData();
			}
		},

		// beforeUpdate() {
		// }
	};
</script>
<style>
</style>
